import { withStyles } from '@material-ui/styles';
import WifiThermostatPanel from './WifiThermostatPanel';
import styles from './styles';

export default withStyles(styles)(WifiThermostatPanel);
